import { RJParser } from "../../RJParser";
import { LomaOperatorProcessor } from "./LomaOperatorProcessor";

export class LomaParser extends RJParser
{
  readonly lomaOperatorProcessor:LomaOperatorProcessor;

  constructor()
  {
    super();

    this.lomaOperatorProcessor = new LomaOperatorProcessor( this );
    this._operatorsProcessor = this.lomaOperatorProcessor;     
  }


}